export default {
  assessmentHeading: {
    id: 'buyback_refurbisher_order_customer_assessment_title',
    defaultMessage: 'Customer Assessment',
  },
  viewCounteroffer: {
    id: 'buyback_refurbisher_order_view_counteroffer',
    defaultMessage: 'View counteroffer',
  },
}
